<template>
        <div class="container">
                <h1>Meus Eventos</h1>
                
                <div v-if="this.error" class='alert alert-danger'>
                        {{ this.error }}
                </div>


                <div v-if="events" v-for='event in events'>
                       <router-link :to="`/admin/events/${event.id}/registrations`">{{event.name}}</router-link>
                </div>
        </div>
</template>


<script>


import api from '@/api';
export default {

    data(){
      return {  error:false,
                events:false
      }
    },

    created:async function(){
                let res
                try{
                   res = await  api.getJSONAsync('events');
                    this.events = res
                }catch(e){
                        this.error = e
                }
                console.log(res)
                if(res == false){
                        this.error = "Ocorreu um Erro!"
                }
        },
        watch: {
                id:async function(){
                this.error = false;
                        let res = await this.$store.dispatch('PurchaseStore/loadMyRegistrations',this.$route.params.id)
                        if(res == false){
                                this.error = "Ocorreu um Erro!"
                        }
                }
        },
        computed:{
                id:function(){
                        return this.$route.params.id
                },
                purshaseProducts:function(){
                        return this.$store.getters['PurchaseStore/myRegistrations']
                }
        }

}
</script>

<style>

</style>
